export default "__VITE_ASSET__ImrzvfvM__"